function uniqBy(array, iteratee) {
  const seen = {};
  if (iteratee) return array.filter(value => seen.hasOwnProperty(iteratee(value)) ? false : seen[iteratee(value)] = true);
  return array.filter(value => seen.hasOwnProperty(value) ? false : seen[value] = true);
}

export { uniqBy };
